import React, {useState, useEffect} from 'react';
import cx from 'classnames';
import {Flex, Title, CheckBox, Text, Link, Button} from '@priority-software/priority-style-react';
import styles from './UpgradeDialog.module.scss';
import {texts} from '../Announcement/data/texts';
import {Topic} from './types';
import {isRTL} from '../../Localization';

type Props = {
    onAccept: (data: any) => void;
    onDecline: () => void;
};

export const SecondSlide = ({onAccept, onDecline}: Props) => {
    const [topics, setTopics] = useState<Topic[]>(null);

    useEffect(() => {
        const getLabels = (): string[] => {
            return [
                texts.label1,
                texts.label2,
                texts.label3,
                texts.label4,
                texts.label5,
                texts.label6
            ];
        };
        const topics = getLabels()
            .filter(l => !!l)
            .map(t => {
                return {label: t, selected: false};
            });
        setTopics(topics);
    }, []);

    const isRtl = isRTL();
    const lang = isRtl ? 'il/' : '';
    const privacyPolicyLink = `https://www.priority-software.com/${lang}privacy-policy/`;

    const toggleSelect = (label: string) => {
        const tCopy = [...topics];
        const idx = tCopy.findIndex(t => t.label === label);
        tCopy[idx].selected = !tCopy[idx].selected;
        setTopics(tCopy);
    };

    const handleApprove = () => {
        onAccept(topics);
    };

    const disabled = topics?.every(t => !t.selected);

    return (
        <Flex direction="column">
            <Title
                skin="h4"
                textColor="primary-700"
                text={texts.personalizedUpdates}
                componentClasses={cx(styles.paragraphGap, styles.alignStart)}
            />
            <Text skin="paragraph-2" textColor="primary-700" componentClasses={styles.alignStart}>
                {texts.topicsTitle}
            </Text>
            <Flex componentClasses={styles.checkBoxesWrapper} wrap>
                {topics?.map(topic => {
                    const {label, selected} = topic;
                    return (
                        <CheckBox
                            key={label}
                            onChange={() => toggleSelect(label)}
                            componentClasses={styles.checkBox}
                            checked={selected}
                        >
                            <Text skin="paragraph-2">{label}</Text>
                        </CheckBox>
                    );
                })}
            </Flex>
            <Text skin="tiny" textColor="primary-700">
                {texts.byClicking}{' '}
                <Text tag="span" skin="tiny" fontWeight="bold">{`"${texts.accept}"`}</Text>{' '}
                <Text tag="span" skin="tiny">
                    {texts.termsAndConditionsStart}{' '}
                </Text>
                <Link textSize="inherit" onClick={() => window?.open(privacyPolicyLink, '_blank')}>
                    {texts.privacyPolicy}
                </Link>
                <Text tag="span" skin="tiny">
                    {' '}
                    {texts.termsAndConditionsEnd}
                </Text>
            </Text>
            <Flex componentClasses={styles.footer}>
                <Button wideButton size={'medium'} skin="secondary" onClick={onDecline}>
                    {texts.decline}
                </Button>
                <Button wideButton size={'medium'} onClick={handleApprove} disabled={disabled}>
                    {texts.accept}
                </Button>
            </Flex>
        </Flex>
    );
};
